import { columns } from "./columns"

export const footer = {
    columns,
    copyright: `Powered by EMTECH · © 2026 EMTECH, Inc. All rights reserved.`,
    logo: {
        src: {
            light: "/cbn-logo-light.svg", dark: "/cbn-logo-dark.svg"
        },
        alt: "Central Bank of Nigeria",
        width: 160,
    },
}
